"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLPreElementImpl extends HTMLElementImpl { }

module.exports = {
  implementation: HTMLPreElementImpl
};
